/**
 * Compress and resize an image for AI analysis.
 * Reduces file size by ~90% while keeping enough detail for OCR.
 * @param {string} dataUrl - Original data URL (from FileReader or canvas)
 * @param {number} maxDim - Max width/height in pixels (default 800)
 * @param {number} quality - JPEG quality 0-1 (default 0.6)
 * @returns {Promise<string>} - Compressed base64 string (without data:... prefix)
 */
export function compressImageForAI(dataUrl, maxDim = 800, quality = 0.6) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      let { width, height } = img;
      if (width > maxDim || height > maxDim) {
        const ratio = Math.min(maxDim / width, maxDim / height);
        width = Math.round(width * ratio);
        height = Math.round(height * ratio);
      }
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
      const compressed = canvas.toDataURL('image/jpeg', quality);
      resolve(compressed.split(',')[1]);
    };
    img.onerror = () => reject(new Error('Errore caricamento immagine'));
    img.src = dataUrl;
  });
}
